module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/header_logo-c7e9315c4f23ad5c8475abe03cd43d2e.png";